import defaultStyles from "./what-we-do-default.module.scss";
import "./what-we-do-mobile.module.scss";
import DomPurify from "isomorphic-dompurify";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LayoutStyleTypes, useLayoutType } from "@/util-react/layout.tsx";
import classNames from "classnames";
import { FixBreadcrumb, useBreadcrumbs } from "@/elements-react/fix-breadcrumb";
import { Url } from "@/helpers/url.ts";

const getStaticPageLayoutStyleType = (layoutStyleType: string) => {
  switch (layoutStyleType) {
    case LayoutStyleTypes.TYPE_XXS:
    case LayoutStyleTypes.TYPE_XS:
    case LayoutStyleTypes.TYPE_SM:
    case LayoutStyleTypes.TYPE_MD:
      return LayoutStyleTypes.TYPE_SM;
    case LayoutStyleTypes.TYPE_LG:
      return LayoutStyleTypes.TYPE_LG;
    case LayoutStyleTypes.TYPE_XL:
      return LayoutStyleTypes.TYPE_XL;
    case LayoutStyleTypes.TYPE_XXL:
    default:
      return LayoutStyleTypes.TYPE_XXL;
  }
};

export function useWhatWeDoCommon(staticPageContent: string) {
  const { t } = useTranslation();
  const { layoutStyleType } = useLayoutType();

  const content = useMemo(() => {
    return DomPurify.sanitize(staticPageContent);
  }, [staticPageContent]);
  const staticPageLayoutStyleType = useMemo(() => getStaticPageLayoutStyleType(layoutStyleType), [layoutStyleType]);

  const breadcrumbs = [
    {
      label: t("4kw4rc01m4c94cns.what-we-do", "What we do"),
      url: Url.to("what-we-do-page"),
    },
  ];

  useBreadcrumbs(breadcrumbs);

  const renderContent = () => {
    const contentClassnames = classNames(defaultStyles[staticPageLayoutStyleType]);

    return (
      <div className={defaultStyles.wrapper}>
        <div className={contentClassnames}>
          <div className="static-page-content">
            <div className={defaultStyles.breadcrumbsNavigation}>
              <FixBreadcrumb />
            </div>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    );
  };

  return {
    renderContent,
  };
}
